import type { BaseAPIParams } from 'lib/utils/BaseAPIParams';
import { BaseApiClient } from '../baseApiClient';

export type ReplayMessagesArg = {
  dateFrom: string | undefined;
  dateTo: string | undefined;
  dataSourceId: string;
};

export type PostDecoderArg = unknown;

export type DecoderFilter = BaseAPIParams<unknown> & {
  dateFrom?: Date | string;
  dateTo?: Date | string;
  search?: string;
};

export type DecoderLog = {
  url?: string;
  body: unknown;
  createdAt?: string;
};

export type DecoderLogEntry =
  | { status: 'ok'; log: DecoderLog; result: unknown[] }
  | { status: 'error'; log: DecoderLog; error: string };

export class DecoderApiClient extends BaseApiClient {
  constructor(jwt: string) {
    super('enmon-tools/decoder', undefined, jwt);
  }

  public async get(filter: DecoderFilter, signal: AbortSignal | undefined): Promise<DecoderLogEntry[]> {
    const response = await this.axios.get<DecoderLogEntry[]>(``, {
      params: filter,
      signal,
    });

    return response.data;
  }

  public async post(messages: PostDecoderArg, customerId: string, signal: AbortSignal) {
    const response = await this.axios.post('', messages, {
      signal,
      params: {
        customerId,
      },
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  }

  public async replayMessages(payload: ReplayMessagesArg): Promise<void> {
    await this.axios.post(`/replay-messages`, payload);
  }

  public async mbusToJson(payload: string): Promise<void> {
    const response = await this.axios.post('mbus-to-json', { payload });

    return response.data;
  }
}
